import { AttributesMixin, define, Model, type } from "@type-r/models";
import { AssetStateIds } from "../../api/assetStateIds";
import { AssetType } from "../../api/assetType";
import { DateFilter, formatDateFilter } from "../../components/search-bar/filters/date-filter";
import { MultiSelectChipsFilter } from "../../components/search-bar/filters/multiselect-chips-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";


const defaultSort = {
    attr: "createdOn",
    asc: false
};

export const SortOptions = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export const RemittanceAdviceStateOptions = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: AssetStateIds.Pending,
        label: 'Pending'
    },
    {
        value: AssetStateIds.Digitized,
        label: 'Digitized'
    }
]

export interface RemittanceAdviceFilter extends AttributesMixin<typeof RemittanceAdviceFilter> { }

@define
export class RemittanceAdviceFilter extends Model {
    static attributes = {
        filterAll: '',
        payors: type(MultiSelectChipsFilter),
        payees: type(MultiSelectChipsFilter),
        amount: type(TextFilter),
        currency: type(TextFilter),
        paymentDate: type(DateFilter),
        originalFileName: type(TextFilter),
        importJobId: type(TextFilter),
        invoiceNumber: type(TextFilter),
        faceValue: type(TextFilter),
        assetUid: type(TextFilter),
        stateId: 0,
        sortBy: type(defaultSort),
    }

    reset() {
        this.filterAll = '';
        this.payors.$.selected.set([] as any);
        this.payees.$.selected.set([] as any);
        this.amount.$.value.set('');
        this.currency.$.value.set('');
        this.paymentDate.$.date.set(null);
        this.originalFileName.$.value.set('');
        this.importJobId.$.value.set('');
        this.invoiceNumber.$.value.set('');
        this.faceValue.$.value.set('');
        this.assetUid.$.value.set('');
      }

    mapToQuery(skip: number = 0, take: number = 30, stateId?: number) {
        const params: any = { skip: skip, count: take, assetTypeId: AssetType.remittanceAdvice};

        if (this.payors.selected && this.payors.selected.length)
        {
            params.payors = this.payors.selected;
            params.payors = params.payors.join('|');
        }
        else if (this.payees.selected && this.payees.selected.length)
        {
            params.payees = this.payees.selected;
            params.payees = params.payees.join('|');
        }
        else if (this.amount.value)
        {
            params.amount = this.amount.value;        
        }
        else if (this.currency.value)
        {
            params.currency = this.currency.value;
        }
        else if (this.paymentDate.date)
        {
            params.paymentDate = formatDateFilter(this.paymentDate.date);
        }
        else if (this.filterAll && this.filterAll.length > 2)
        {
            params.matchAll = this.filterAll; 
        }
        else if (this.originalFileName.value)
        {
            params.originalFileName = this.originalFileName.value
        }
        else if (this.importJobId.value)
        {
            params.importJobId = this.importJobId.value
        }
        else if (this.invoiceNumber.value)
        {
            params.invoiceNumber = this.invoiceNumber.value
        }
        else if (this.faceValue.value)
        {
            params.faceValue = this.faceValue.value
        }
        else if (this.assetUid.value) {
            params.uid = this.assetUid.value;
        }

        if (stateId > 0)
        {
            params.stateId = stateId;
        }
        else if (this.stateId > 0)
        {
            params.stateId = this.stateId;
        }

        if (this.sortBy)
        {
            params.sortBy = this.sortBy.attr;
            params.sortDirection = this.sortBy.asc ? 'asc' : 'desc';
        }

        return params;
    }
}